import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';
import { getButtonHandler } from '../../utils/buttonHandlers';

const ButtonElement = ({ element }) => {
  const onboardingContext = useOnboarding();
  const { goToNextScreen, isCurrentScreenValid, buttonLoadingStates } = onboardingContext;
  const style = applyStyles(element);

  // Check if this button is in loading state
  const isLoading = element.handler && buttonLoadingStates?.get(element.handler) === true;

  const handleClick = () => {
    // Don't handle click if button is loading
    if (isLoading) return;

    // Check if there's a custom handler specified
    if (element.handler) {
      const customHandler = getButtonHandler(element.handler);
      
      if (customHandler) {
        // Call custom handler with context and element
        customHandler(onboardingContext, element);
      } else {
        console.warn(`Custom handler "${element.handler}" not found, using default behavior`);
        goToNextScreen();
      }
    } else {
      // Default behavior: go to next screen
      goToNextScreen();
    }
  };

  // Build className with optional variant
  const className = `element-button${element.variant ? ` ${element.variant}` : ''}${isLoading ? ' loading' : ''}`;

  return (
    <button 
      className={className}
      style={style}
      onClick={handleClick}
      disabled={!isCurrentScreenValid || isLoading}
    >
      {isLoading ? (
        <span className="button-spinner">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round">
              <animate attributeName="stroke-dasharray" values="1,150;90,150;1,150" dur="1.5s" repeatCount="indefinite" />
              <animate attributeName="stroke-dashoffset" values="0;-35;-124" dur="1.5s" repeatCount="indefinite" />
            </circle>
          </svg>
        </span>
      ) : (
        element.text
      )}
    </button>
  );
};

export default ButtonElement;

